import { CubeQueryRecord } from '../types/cubeQueryTypes';
import { getPageNameFromPath } from './componentNameExtractor';
import { QueryStore } from './QueryStore';

export class QueryAnalyzer {
  constructor(private queryStore: QueryStore) {}

  getQueriesByComponent(): Record<string, CubeQueryRecord[]> {
    const queries = this.queryStore.getQueries();
    return queries.reduce<Record<string, CubeQueryRecord[]>>((grouped, query) => {
      if (!grouped[query.componentName]) {
        grouped[query.componentName] = [];
      }
      grouped[query.componentName].push(query);
      return grouped;
    }, {});
  }

  getQueriesByPage(): Record<string, CubeQueryRecord[]> {
    const queries = this.queryStore.getQueries();
    return queries.reduce<Record<string, CubeQueryRecord[]>>((grouped, query) => {
      const pageName = getPageNameFromPath(query.pagePath);
      if (!grouped[pageName]) {
        grouped[pageName] = [];
      }
      grouped[pageName].push(query);
      return grouped;
    }, {});
  }
}
